<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body">
        <div class="pay-mains">
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">发送主题</div>
              <div class="itemNum">{{form.title}}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">发送人</div>
              <div class="itemNum">{{form.oxCname}}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">发送时间</div>
              <div class="itemNum">{{formatDate(form.oxCtime)}}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">消耗短信</div>
              <div class="itemNum">{{form.consumeSuccessNum}} 条</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">发送内容</div>
              <div class="itemNum">{{form.content}}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">发送人数：{{ form.totalNum }}人</div>
              <div class=" space-between">
                <div class="cur isBlue w100b" @click="showFlag1 = !showFlag1">{{showFlag1 ? '收起':'展开'}}</div>
                <div class="itemNum ml10" style="width: 340px; min-width: 340px;" v-if="showFlag1">{{form.receiveInfo}}</div>
              </div>
            </div>
            <div class="flex-row mb30" v-if="form.receiveSuccessInfo">
              <div class="itemName">{{numberMessage}}</div>
              <div class=" space-between">
                <div class="cur isBlue w100b" @click="showFlag2 = !showFlag2">{{showFlag2 ? '收起':'展开'}}</div>
                <div class="itemNum ml10" style="width: 340px; min-width: 340px;" v-if="showFlag2">{{form.receiveSuccessInfo}}</div>
              </div>
            </div>
            <div class="flex-row mb30" v-if="form.receiveFailInfo">
              <div class="itemName">{{failMessage}}</div>
              <div class=" space-between">
                <div class="cur isBlue w100b" @click="showFlag3 = !showFlag3">{{showFlag3 ? '收起':'展开'}}</div>
                <div class="itemNum ml10" style="width: 340px; min-width: 340px;" v-if="showFlag3">{{form.receiveFailInfo}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="drawer-footer pr24 pb10">
          <el-button @click="back">返回</el-button>
          <el-button @click="save" type="primary" v-if="form.canResendFlag">重新发送</el-button>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import { encrypt } from "../../../assets/javascript/untils";
export default {
  mixins: [minxin],
  components: {
    drawer
  },
  data() {
    return {
      addEditShow: false,
      addEditTitle: "发送详情",
      dialogHide: false,
      form: {
        orderType: ""
      },
      dialogHide: false,
      numberMessage: '',
      failMessage: '',
      showFlag1: true,
      showFlag2: false,
      showFlag3: false
    };
  },
  created() {
    
    this.init();
  },
  mounted() {
    
  },
  methods: {
    //  页面初始化函数
    init() {
      this.$on("set", function(org) {
        this.$api.get(this.$url.smsTemplate.get, {
            id: org
          }).then(res => {
            if (res) {
              console.log(res);
              this.addEditShow = true;
              this.form = res;
              this.numberMessage = res.successItemNum + '位发送成功';
              this.failMessage = res.failItemNum + '位发送失败';
            }
          }).catch(error => {});
      });
    },
    back() {
      this.addEditShow = false;
      this.$emit("change", false);
    },
    save () {
      console.log('this.form.id: ',this.form.id);
      let arr = encrypt(
        JSON.stringify({
          id: this.form.id
        })
      );
      this.$api.post(this.$url.smsTemplate.messageReSendBatchSms, arr).then(res => {
        if (res) {
          this.addEditShow = false;
          this.$message.success('操作成功');
          this.$emit("change", true);
        }
      }).catch(error => {});
      
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
/deep/ div .el-drawer__body {
  padding: 0 !important;
}
.pay-mains {
  padding: 20px 0;
}
</style>